import { render, staticRenderFns } from "./PatientDetail.vue?vue&type=template&id=ba5ef8de&"
import script from "./PatientDetail.vue?vue&type=script&lang=js&"
export * from "./PatientDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports